import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import store from './redux'

const { REACT_APP_APPNAME_IIS } = window['runConfig'];

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={ REACT_APP_APPNAME_IIS ? `/${REACT_APP_APPNAME_IIS}` :  ''} >
      <App />
    </BrowserRouter>
  </Provider>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
